import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { SessionService } from 'src/app/core/services/session-service';
import { MenuItems, MenuItem } from './header.model';
import { ROUTE_PATHS } from '../../core/constants/app-routes.constant';
import { LoginService } from 'src/app/login/login.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule
  ]
})

export class HeaderComponent implements OnInit {

  activeMenu: MenuItem | null;
  menuItems: MenuItem[] = [];
  showLogoutMenu: boolean = true;

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.populateMenuItems();
    this.setActiveMenu(this.router.url);

    this.route.queryParams.subscribe(params => {
      const showLogoutMenuParam = params['showLogoutMenu'];
      if (showLogoutMenuParam =='false'){
      this.showLogoutMenu = false;
      } 
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setActiveMenu(event.url);
      }
    });
  }

  private populateMenuItems(): void  {
    if (this.sessionService.isAdminUser()) {
      this.menuItems.push(MenuItems.DASHBOARD),
      this.menuItems.push(MenuItems.CONTEST),
      this.menuItems.push(MenuItems.QUESTION),
      this.menuItems.push(MenuItems.USER)
    }
  }

  private setActiveMenu(url: string): void  {
    if (url.startsWith(ROUTE_PATHS.user.root())) {
      this.activeMenu = this.menuItems.find(item => item.label === MenuItems.USER.label) || null;
    } else if (url.startsWith(ROUTE_PATHS.contest.root())) {
      this.activeMenu = this.menuItems.find(item => item.label === MenuItems.CONTEST.label) || null;
    } else if (url.startsWith(ROUTE_PATHS.question.root())) {
      this.activeMenu = this.menuItems.find(item => item.label === MenuItems.QUESTION.label) || null;
    } else{
      this.activeMenu = this.menuItems.find(item => item.link === url) || null;
    }
  }

  navigate(menuItem: any): void {
    this.activeMenu = menuItem;
    this.router.navigateByUrl(menuItem.link);
  }


  logout(): void {
    if (this.showLogoutMenu) {
    this.sessionService.logout();
    this.loginService.logout().subscribe();
    this.router.navigate([ROUTE_PATHS.auth.login()]);
  }
}
}